import moment from 'moment';
import column from '../../../../common/list-table/helpers/columns';

export const leftTableColumns = (data, { selectedIATACode, updateSelectedIATACode }) => {
  const { FilteredTextColumn } = column(data);

  const getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo.original.iata === selectedIATACode ? '#dbffdb' : null,
        },
        onClick: () => {
          updateSelectedIATACode(rowInfo.original.iata);
        },
      };
    }
    return {};
  };

  return [{
    Header: '',
    columns: [
      new FilteredTextColumn('Country', 'countryCode').withWidth(85).withGetProps(getTrProps),
      new FilteredTextColumn('Airport', 'iata').withWidth(85).withGetProps(getTrProps),
    ],
  }];
};

export const rightTableColumns = (data, onRowEdit, onRowDelete, userRole) => {
  const { ActionColumn, FilteredTextColumn, FilteredDateColumn } = column(data);

  const getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          fontStyle: rowInfo.original.manualEntry ? 'italic' : 'inherit',
        },
      };
    }
    return {};
  };

  const conditionalDisplay = (row) => row.original.manualEntry && (row.original.validTo ? moment(row.original.validTo).isSameOrAfter(moment().startOf('day')) : true);

  return [{
    Header: '',
    columns: [
      new FilteredTextColumn('Flight', 'flight').withGetProps(getTrProps),
      new FilteredTextColumn('Origin', 'origin').withGetProps(getTrProps),
      new FilteredTextColumn('Monday', 'monday').withGetProps(getTrProps),
      new FilteredTextColumn('Tuesday', 'tuesday').withGetProps(getTrProps),
      new FilteredTextColumn('Wednesday', 'wednesday').withGetProps(getTrProps),
      new FilteredTextColumn('Thursday', 'thursday').withGetProps(getTrProps),
      new FilteredTextColumn('Friday', 'friday').withGetProps(getTrProps),
      new FilteredTextColumn('Saturday', 'saturday').withGetProps(getTrProps),
      new FilteredTextColumn('Sunday', 'sunday').withGetProps(getTrProps),
      new FilteredDateColumn('Valid from', 'validFrom').withGetProps(getTrProps),
      new FilteredDateColumn('Valid to', 'validTo').withGetProps(getTrProps),
      new ActionColumn([['EDIT', 'flight', onRowEdit, true, conditionalDisplay],
        ['DELETE', 'flight', onRowDelete, true, conditionalDisplay]]).withShow(['IPC_ADMIN', 'OPER_ADMIN'].includes(userRole)),
    ],
  }];
};
